<style scoped lang="scss">
$font_color: rgba(31, 31, 31, 0.49);
$border_color: #ebeef5;
.policy_index {
    // width: 1310px;
    margin: 0 auto;
}
.policy_search {
    box-sizing: border-box;
    height: 63px;
    display: flex;
    border: 1px solid $border_color;
    padding-left: 40px;
    align-items: center;
    margin-bottom: 20px;
    button {
        width: 100px;
        height: 34px;
        line-height: 8px;
        margin-right: 30px;
    }
}
.policy_search_box {
    font-size: 12px;
    color: $font_color;
    margin-right: 30px;
    span {
        margin-right: 10px;
    }
}
.policy_table {
    font-size: 12px;
    color: $font_color;
    box-sizing: border-box;
    border: 1px solid $border_color;
    border-bottom: none;
    h3 {
        height: 42px;
        line-height: 42px;
        box-sizing: border-box;
        padding-left: 10px;
    }
}
.policy_page {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
.table_username {
    color: rgba(144, 207, 227, 1);
    cursor: pointer;
}
</style>
<style lang='scss'>
.policy_index {
    .el-select {
        width: 100px;
    }
    .el-table th {
        background: #f7f7f7 !important;
        color: #333 !important;
        font-weight: 500;
    }
    .el_table td {
        color: rgba(31, 31, 31, 0.49) !important;
    }
    .el-table--enable-row-transition .el-table__body td {
        transition: background-color 0.25s ease;
    }
    .el-table th > .cell {
        line-height: 34px;
    }
    .el-table td,
    .el-table th {
        padding: 16px 0;
    }
    .el-table__empty-block {
        max-height: 100px !important;
    }
    .el-select {
        width: 220px;
    }
    .el-select .el-input .el-select__caret {
        line-height: 34px;
    }
    .el-select-dropdown__item{
        width:220px !important;
    }
}
</style>

<template>
    <div class="policy_index">
        <crumbs :trail="'投放明细'" :subTrail="` > ${operateType}`" :href="'/iad_puton/planlist'"></crumbs>
        <div class="policy_search">
            <div class="policy_search_box">
                <span>
                    素材ID
                </span>
                <template>
                    <el-select v-model="oplicyId" clearable filterable placeholder="请选择">
                        <el-option v-for="(item,index) in oplicyIdOptions" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
            <div class="policy_search_box">
                <span>
                    素材名称
                </span>
                <template>
                    <el-select v-model="oplicyName" clearable filterable placeholder="请选择">
                        <el-option v-for="(item,index) in oplicyNameOptions" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
            <div class="policy_search_box">
                <span>
                    日期
                </span>
                <el-date-picker class ="picker" v-model="dataList" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <el-button type="primary" @click='searchClick'>搜索</el-button>
            <el-button type="primary" @click="checketOut">导出</el-button>
        </div>
        <div class="policy_table">
            <h3>
                <i class="el-icon-edit-outline"></i>
                素材数据（共{{total}}条）
            </h3>
            <template>
                <el-table :data="tableData" v-loading="loading" :empty-text='emptyText' style="width: 100%">
                    <el-table-column label="操作" align='center' min-width="119">
                        <template slot-scope="scope">
                            <div class="table_username"  @click="accountRoute(scope.row)">分媒体数据</div>
                        </template>
                    </el-table-column>
                    <el-table-column property="StatisDate" label="日期" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column property="MaterialId" label="素材ID" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column property="MaterialName" label="素材名称" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column property="PutOnId" label="计划ID" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column property="AdTaskName" label="计划名称" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column property="ExposureCount" label="曝光" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column property="ClickPvCount" label="计费点击" align='center' min-width="119">
                    </el-table-column>
                    <el-table-column label="点击率" align='center' min-width="119">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.CTR + '%'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="InCome" label="消耗" align='center' min-width="119">
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <div class="policy_page">
            <el-pagination :current-page="pageIndex" background :page-size="20" @current-change="handleCurrentChange" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
// 面包屑
import crumbs from "../public/crumbs/crumbs";
import { materialInfor } from "api/policyservers";
import {formatDate} from '../../common/js/common'
export default {
    data() {
        return {
            operateType: "素材数据",
            oplicyIdOptions: [],
            oplicyId: "",
            oplicyNameOptions: [],
            oplicyName: "",
            dataList: ["", ""],
            total: 0,
            tableData: [],
            loading: false,
            emptyText: "当前暂无数据",
            pageIndex: 1,
            ParentPutOnId: ""
        };
    },

    components: {
        crumbs
    },

    computed: {},

    created() {
        this.loading= true
        this.ParentPutOnId = this.$route.query.PutOnId
        this.ajaxInfo();
    },

    updated() {},

    mounted() {},

    destroyed() {},

    methods: {

        accountRoute(id) {
            window.location.href=
            "/IAD_MediaData/MediaInit#/MediaInit?PutOnId="+
            this.$route.query.PutOnId+
            "&MaterialId=" +
            id.MaterialId +
            "&StatisDate=" +
            id.StatisDate

            // this.$router.push({
            //     path: "/MediaInit",
            //     query: {
            //         PutOnId: this.$route.query.PutOnId,
            //         MaterialId: id.MaterialId,
            //         StatisDate: id.StatisDate
            //     }
            // });
        },
        handleCurrentChange(val) {
            this.loading = true;
            this.pageIndex = val * 1;
            this.ajaxInfo();
        },
        searchClick() {
            this.loading = true;
            this.ajaxInfo();
        },
        checketOut() {
            var beginTime = "" ;
            var endTime = "";
            beginTime = this.dataList ? formatDate(this.dataList[0]) :"";
            endTime = this.dataList ? formatDate(this.dataList[1]) :"";
            window.location.href =
                "/IAD_MaterialData/Export?PutonId=" +
                this.ParentPutOnId +
                "&beginDate=" +
                beginTime +
                "&endDate=" +
                endTime +
                "&oplicyId=" +
                this.oplicyId +
                "&MaterialName=" +
                this.oplicyName
        },
        ajaxInfo() {
            materialInfor({
                PutonId: this.ParentPutOnId,
                beginDate: this.dataList ? formatDate(this.dataList[0]) : "",
                endDate: this.dataList ? formatDate(this.dataList[1]) : "",
                page: this.pageIndex,
                MaterialId: this.oplicyId,
                MaterialName: this.oplicyName
            })
                .then(res => {
                    this.loading = false;
                    if (res.TotalNum == 0) {
                        this.tableData = [];
                        this.oplicyIdOptions = [];
                        this.oplicyNameOptions = [];
                        this.total = res.data.TotalNum;
                    } else {
                        this.total = res.data.TotalNum;
                        this.tableData = res.data.Items;
                        this.oplicyIdOptions = [];
                        this.oplicyNameOptions = [];
                        res.data.Items.map((ele, index) => {
                            this.oplicyIdOptions.push({
                                lable: index,
                                value: ele.MaterialId
                            });
                            if(ele.MaterialName){
                                this.oplicyNameOptions.push({
                                    lable: index,
                                    value: ele.MaterialName
                                });
                            }

                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.tableData = [];
                    this.oplicyIdOptions = [];
                    this.oplicyNameOptions = [];
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/policy-data/material-data.vue